import { initializeApp } from "firebase/app"
import { getAuth } from "firebase/auth"
import { getFirestore } from "firebase/firestore"
import { getStorage } from "firebase/storage"
import { getMessaging, onMessage, getToken } from "firebase/messaging"
import { getDatabase } from "firebase/database"
import axios from "axios"

// Get the user from localStorage
const user = JSON.parse(localStorage.getItem("user"))

// Firebase Configuration
export const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_A,
  authDomain: process.env.REACT_APP_FIREBASE_A_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  databaseURL:
    "https://fireynash-default-rtdb.europe-west1.firebasedatabase.app/",
}

// Initialize Firebase
const app = initializeApp(firebaseConfig)
export const auth = getAuth(app)
export const db = getFirestore(app)
export const rtdb = getDatabase(app)
export const storage = getStorage(app)

export const messaging = getMessaging(app)

/**
 * Request Notification Permissions
 * Handles both FCM for Chrome/Android and Safari Push Notifications
 */
export const requestNotificationPermission = async (vapidKey) => {
  try {
    // Check if Notification API is available
    if ("Notification" in window) {
      const permission = await Notification.requestPermission()

      if (permission === "granted") {
        // Handle FCM (Chrome/Android)
        if ("serviceWorker" in navigator) {
          const fcmToken = await getToken(messaging, { vapidKey })

          if (fcmToken) {
            // Save the FCM token to your backend
            await axios.post("/api/save-fcm-token", {
              userId: user?.id,
              fcmToken,
              role: user.role,
            })

            console.log("FCM token saved successfully.")
          } else {
            console.error("Failed to retrieve FCM token.")
          }
        }
      }
    } else {
      console.error("Notification API is not available in this browser.")
    }
  } catch (error) {
    console.error("Error requesting notification permission:", error)
  }
}

// Listen for foreground messages
onMessage(messaging, (payload) => {
  console.log("Message received in foreground:", payload)

  // Display notification for FCM messages in the foreground
  const notificationTitle = payload.notification.title
  const notificationOptions = {
    body: payload.notification.body,
    icon: "/icon-192x192.png",
  }

  new Notification(notificationTitle, notificationOptions)
})

export default app
